import { useMutation, UseMutationResult, useQueryClient } from 'react-query';

import { getTokenWithType } from './useAuth';

import { cloneProcedure } from 'utils/urls';

import { ErrorModal } from 'types/modalTypes';

export async function procedureClone({
  accountId,
  procedureFileIds,
}: TVariables): Promise<TResult> {
  const response = await fetch(cloneProcedure(accountId), {
    method: 'POST',
    headers: {
      Authorization: getTokenWithType(),
      'content-type': 'application/json',
    },
    body: JSON.stringify(procedureFileIds),
  });
  return response.json();
}

type TError = ErrorModal;

type TResult = {
  Data: Array<number>;
  IsSuccess: boolean;
  StatusCode: number;
} & ErrorModal;

type TVariables = {
  accountId: number;
  procedureFileIds: Array<string>;
};

type TSnapshot = unknown;

function useCloneProcedure(): UseMutationResult<
  TResult,
  TError,
  TVariables,
  TSnapshot
> {
  const queryClient = useQueryClient();
  return useMutation(async (params: TVariables) => {
    const fetchResponse = await procedureClone(params);
    if (fetchResponse.Data) {
      queryClient.invalidateQueries(['get_procedure_builder_procedures'], {
        refetchInactive: true,
      });
    } else if (fetchResponse.Errors) throw fetchResponse;
    return fetchResponse;
  });
}

export { useCloneProcedure };
